'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _MessageFormatter = require('@/libs/MessageFormatter');

var _MessageFormatter2 = _interopRequireDefault(_MessageFormatter);

var _BufferSettings = require('./BufferSettings');

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

var _ChannelInfo = require('./ChannelInfo');

var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);

var _ChannelBanlist = require('./ChannelBanlist');

var _ChannelBanlist2 = _interopRequireDefault(_ChannelBanlist);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        ChannelInfo: _ChannelInfo2.default,
        ChannelBanlist: _ChannelBanlist2.default
    },
    props: ['buffer', 'sidebarState'],
    data: function data() {
        return {
            buffer_settings_open: false,
            pluginUiChannelElements: _GlobalApi2.default.singleton().channelHeaderPlugins,
            pluginUiQueryElements: _GlobalApi2.default.singleton().queryHeaderPlugins,
            viewTopic: false,
            prompts: {
                closeChannel: false
            }
        };
    },
    computed: {
        isJoined: function isJoined() {
            var buffer = this.buffer;
            return buffer.getNetwork().state === 'connected' && buffer.joined;
        },
        isConnected: function isConnected() {
            return this.buffer.getNetwork().state === 'connected';
        },
        formattedTopic: function formattedTopic() {
            var showEmoticons = _state2.default.setting('buffers.show_emoticons');
            var blocks = (0, _MessageFormatter2.default)(this.buffer.topic, { extras: false });
            var content = TextFormatting.styleBlocksToHtml(blocks, showEmoticons, null);
            return content.html;
        }
    },
    watch: {
        buffer: function watchBuffer() {
            this.buffer_settings_open = false;
        }
    },
    created: function created() {
        var _this = this;

        this.listen(_state2.default, 'document.clicked', function (e) {
            if (!_this.$el.contains(e.target)) {
                (0, _keys2.default)(_this.prompts).forEach(function (prompt) {
                    _this.prompts[prompt] = false;
                });
            }
        });
    },

    methods: {
        showPrompt: function showPrompt(prompt) {
            this.prompts[prompt] = true;
        },

        isChannel: function isChannel() {
            return this.buffer.isChannel();
        },
        isServer: function isServer() {
            return this.buffer.isServer();
        },
        isQuery: function isQuery() {
            return this.buffer.isQuery();
        },
        isSpecial: function isSpecial() {
            return this.buffer.isSpecial();
        },
        showNetworkSettings: function showNetworkSettings(network) {
            network.showServerBuffer('settings');
        },
        onConnectButtonClick: function onConnectButtonClick() {
            var network = this.buffer.getNetwork();
            if (!network.connection.server) {
                network.showServerBuffer('settings');
            } else {
                network.ircClient.connect();
            }
        },
        showSidebar: function showSidebar() {
            _state2.default.$emit('sidebar.toggle');
        },
        showTopic: function showTopic() {
            this.viewTopic = !this.viewTopic;
        },

        joinCurrentBuffer: function joinCurrentBuffer() {
            var network = this.buffer.getNetwork();
            this.buffer.enabled = true;
            network.ircClient.join(this.buffer.name);
        },
        closeCurrentBuffer: function closeCurrentBuffer() {
            _state2.default.removeBuffer(this.buffer);
        },
        onHeaderClick: function onHeaderClick(event) {
            var channelName = event.target.getAttribute('data-channel-name');
            if (channelName) {
                var network = this.buffer.getNetwork();
                _state2.default.addBuffer(this.buffer.networkid, channelName);
                network.ircClient.join(channelName);
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ContainerHeader"]
window._kiwi_exports.components.ContainerHeader = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContainerHeader.vue
// module id = NG5i
// module chunks = 1